"use client";

import { useTranslations } from "next-intl";
import { useConsent } from "@/components/consent/ConsentProvider";

/** Footer control that reopens cookie preferences (works in every region). */
export function CookieSettingsLink({ className }: { className?: string }) {
  const t = useTranslations("consent");
  const { openPreferences } = useConsent();
  return (
    <button type="button" onClick={openPreferences} className={className}>
      {t("cookieSettings")}
    </button>
  );
}
